import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Component, OnInit, ElementRef, HostListener, AfterViewInit } from '@angular/core';

import { CadastroService } from '../../../../shared/services/auth/cadastro/cadastro.service';

import * as md5 from 'blueimp-md5';

declare var $: any;

@Component({
  selector: 'app-cadastro',
  templateUrl: './cadastro.component.html',
  styleUrls: ['./cadastro.component.scss']
})
export class CadastroComponent implements OnInit, AfterViewInit {
  public contaId = '';

  public img = null;
  public file = null;

  public indexPage = 1;
  public sections: any[] = [];
  public sectionPrefix = 'secao';

  public loaded = false;
  public isOutline = false;
  public isFinished = false;
  public hasOneNotEmpty = false;

  public tipoPessoa = 'Fisica';

  public senha = '';
  public confirmaSenha = '';

  public conta: any = {
    Nome: '',
    Sobrenome: '',
    TipoConta: '',
    Email: '',
    Telefone: '',
    CpfCnpj: '',
    RazaoSocial: '',
    Fantasia: '',
    TipoCadastro: 'PagueLa',
    Senha: '',
    InformacoesBancarias: [{
      Agencia: '',
      AgenciaDigito: '',
      Banco: '',
      ContaCorrente: '',
      ContaCorrenteDigito: ''
    }],
    Enderecos: [{
      Logradouro: '',
      Numero: '',
      Complemento: '',
      Bairro: '',
      Cidade: '',
      Estado: '',
      Cep: ''
    }],
  };

  constructor(
    private title: Title,
    private router: Router,
    private elRef: ElementRef,
    private cadastroService: CadastroService
  ) { }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    const EnterKey = 13;
    if (event.keyCode === EnterKey) { this.nextSection(); }
  }

  ngOnInit() {
    this.setTitle();
  }

  ngAfterViewInit() {
    this.setNumberOfSections();
  }

  setTitle() {
    this.title.setTitle('Pague.lá | Cadastro');
  }

  setNumberOfSections() {
    const divs = document.getElementsByTagName('div');
    for (let x = 0; x < divs.length; x++) {
      if (this.isSection(divs[x])) { this.sections.push(divs[x]); }
    }

    this.sections.pop();
  }

  isSection(e) {
    return (' ' + e.className + ' ').indexOf(this.sectionPrefix) > -1 ? true : false;
  }

  changePage(e) {
    e.target.getAttribute('data-index') > this.indexPage ? this.nextSection() : this.previousSection();
  }

  isInputsEmpty(indexPage) {
    let isEmpty = false;
    const element = this.elRef.nativeElement.querySelector('.' + this.sectionPrefix + '-' + indexPage);
    const inputs = element.querySelectorAll('input');

    if (indexPage === this.sections.length) {
      isEmpty = false;
      return isEmpty;
    }

    for (let i = 0; i < inputs.length; i++) {
      if (!inputs[i].value) {
        inputs[i].parentNode.classList.add('has-error');
        isEmpty = true;
      }
    }

    if (indexPage === 1) {
      const checked = Array.from(inputs).filter((i: any) => i.checked);

      if (checked.length === 0) {
        isEmpty = true;
      }

      for (let i = 0; i < inputs.length; i++) {
        inputs[i].parentNode.classList.add('has-error');
      }
    }

    if (indexPage === 4) {
      if (!this.isValidEmail(this.conta.Email) || this.senha.length < 6) {
        this.elRef.nativeElement.querySelector('#inputEmail').parentNode.classList.add('has-error');
        isEmpty = true;
      }

      if (this.senha !== this.confirmaSenha || this.confirmaSenha.length < 6) {
        this.elRef.nativeElement.querySelector('#inputSenha').parentNode.classList.add('has-error');
        this.elRef.nativeElement.querySelector('#inputConfirmaSenha').parentNode.classList.add('has-error');

        isEmpty = true;
      }
    }

    return isEmpty;
  }

  isValidEmail(email) {
    const re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/;
    return re.test(String(email).toLowerCase());
  }

  nextSection() {
    const element = document.querySelector('body');
    const inputs: any = element.querySelectorAll('input');
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].parentNode.classList.remove('has-error');
    }

    if (this.isInputsEmpty(this.indexPage)) {
      return;
    }

    if (this.indexPage > this.sections.length) {
      this.goToLogin();
    }

    if (this.indexPage === this.sections.length && !this.isFinished) {
      this.submit();
      return;
    }

    if (this.indexPage !== this.sections.length) {
      $('.btn-next').animate({ 'left': '200px' });
      $('.btn-back').animate({ 'left': '-214px' });
    } else {
      $('.btn-next').animate({ 'left': '0px' });
      $('.btn-back').animate({ 'left': '0px' });

      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Entrar';
    }

    const self = this;
    $('.' + this.sectionPrefix + '-' + this.indexPage).animate({ 'left': '-=500px' }, function() {
      $('.' + self.sectionPrefix + '-' + (self.indexPage + 1)).css('left', '+500px').show();
      $('.' + self.sectionPrefix + '-' + (self.indexPage + 1)).animate({ 'left': '0px' });
      $(this).hide();

      $('.' + self.sectionPrefix + '-' + self.indexPage).find('.form-group').removeClass('has-error');

      self.indexPage++;

      const points = document.getElementsByClassName('ponto');
      for (let x = 0; x < points.length; x++) {
        points[x].classList.remove('ativo');
        if (points[x].getAttribute('data-index') === self.indexPage.toString()) {
          points[x].classList.add('ativo');
        }
      }
    });
  }

  previousSection() {
    if ((this.indexPage - 1) === 1) {
      this.elRef.nativeElement.querySelector('.btn-next button').innerHTML = 'Avançar';
    }

    if (this.indexPage !== 1) {
      const self = this;
      $('.' + this.sectionPrefix + '-' + this.indexPage).animate({ 'left': '+=500px' }, function() {
        $('.' + self.sectionPrefix + '-' + (self.indexPage - 1)).css('left', '-500px').show();
        $('.' + self.sectionPrefix + '-' + (self.indexPage - 1)).animate({ 'left': '0px' });
        $(this).hide();

        self.indexPage--;

        const points = document.getElementsByClassName('ponto');
        for (let x = 0; x < points.length; x++) {
          points[x].classList.remove('ativo');
          if (points[x].getAttribute('data-index') === self.indexPage.toString()) {
            points[x].classList.add('ativo');
          }
        }
      });

      if (this.indexPage - 1 === 1) {
        $('.btn-next').animate({ 'left': '0px' });
        $('.btn-back').animate({ 'left': '0px' });
      } else {
        $('.btn-next').animate({ 'left': '200px' });
        $('.btn-back').animate({ 'left': '-214px' });
      }
    }
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }

  submit() {
    this.enableLoading();

    this.conta.Senha = md5(this.conta.Email + this.senha);

    this.cadastroService.adicionarConta(this.conta).subscribe((data) => {
      this.isFinished = true;

      this.nextSection();
      this.disableLoading();
    }, (err) => {
      console.error(err);
    });
  }

  enableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.add('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').style.opacity = '1';
    this.elRef.nativeElement.querySelector('.btn-registrar').setAttribute('disabled', 'disabled');
  }

  disableLoading() {
    this.elRef.nativeElement.querySelector('.btn-registrar').classList.remove('loading');
    this.elRef.nativeElement.querySelector('.btn-registrar').removeAttribute('disabled');
  }

  selectType(e) {
    if (e.target.value === 'fisica') {
      this.tipoPessoa = 'Fisica';
    }

    if (e.target.value === 'juridica') {
      this.tipoPessoa = 'Juridica';
    }

    this.conta.TipoConta = this.tipoPessoa;
  }

  cleanErrorClass(e) {
    if (e.target.value.length > 0) {
      $(e.target).parent().removeClass('has-error');
    } else {
      $(e.target).parent().addClass('has-error');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/auth/components/cadastro/cadastro.component.ts